// extracted by mini-css-extract-plugin
export default {"productGallery":"CN-z","inQuickShop":"DN-z"};